import { createFileRoute } from '@tanstack/react-router';

import { StructuredColumnsConfigView } from '../../../features/structured-columns/admin-config-view';

export const Route = createFileRoute('/columns/structured-configuration/')({
  staticData: {
    permissionSection: 'settings',
    breadcrumb: 'Structured Columns',
  },
  component: StructuredColumnsConfigView,
});
